import React from 'react';

import PropTypes from 'prop-types';
import { Button, Form } from 'semantic-ui-react';

import _get from 'lodash/get';
import { v4 as uuid } from 'uuid';

import { ExtraDataPropType } from './ExtraDataGroupForm.types';
import ExtraDataForm from '../ExtraDataForm/ExtraDataForm';

const propTypes = {
  extraData: ExtraDataPropType.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default function ExtraDataGroupForm({ extraData, onChange }) {
  const attributesWithIds = (_get(extraData, 'attributes') || []).map((attribute) => ({
    ...(attribute || {}),
    localId: _get(attribute, 'localId') || uuid(),
  }));

  function handleAddExtraData() {
    const newAttributes = [
      ...attributesWithIds,
      { type: 'information', icon: '', label: '', description: '', localId: uuid() },
    ];
    onChange({ attributes: newAttributes });
  }

  function handleRemoveExtraData(index) {
    const newAttributes = attributesWithIds.filter((_, i) => i !== index);
    onChange({ attributes: newAttributes });
  }

  function handleExtraDataChange(index, newData) {
    const newAttributes = [...attributesWithIds];
    newAttributes[index] = newData;
    onChange({ attributes: newAttributes });
  }

  return (
    <Form className="extra-data-section">
      {attributesWithIds.map((data, index) => (
        <ExtraDataForm
          key={`extra-data-${data.localId}`}
          data={data}
          onChange={(newData) => handleExtraDataChange(index, newData)}
          onRemove={() => handleRemoveExtraData(index)}
        />
      ))}
      <Button className="action" onClick={handleAddExtraData}>
        Add Attribute
      </Button>
    </Form>
  );
}

ExtraDataGroupForm.propTypes = propTypes;
